import React, { useCallback, useRef, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogContent,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import customStyles from "app/shared-components/SelectCustomStyle";
import Select from "react-select";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useEffect } from "react";

const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;

export default function KitchenDesignRequestAssign(props) {
  const { open, handleClose } = props;
  const [optionsDesignerList, setOptionsDesignerList] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [selectedUser, setSelectedUser] = useState();

  const handleStartDate = (event) => {
    setStartDate(event);
  };

  const handleEndDate = (event) => {
    setEndDate(event);
  };

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(
        url + `?sort=firstName,asc&size=1000`
      );
      const users = list.data?._embedded?.users.map((data, key) => {
        data.name = data.firstName + " " + data.lastName;
        return data;
      });
      const roleUsers = users.filter((user) =>
        user.roles.includes("ROLE_DESIGNER")
      );
      setOptionsDesignerList(
        roleUsers.map((item) => ({
          value: item.userName,
          label: `${item.firstName} ${item.lastName}`,
        }))
      );
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleUserChange = (value) => {
    if (!value) return;
    setSelectedUser(value);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => handleClose(null)}
        fullWidth
        maxWidth="xs"
      >
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Kitchen Design Assign to Designer
            </Typography>
            <IconButton onClick={() => handleClose(null)}>
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          <Box sx={{ mb: 2 }}>
            {/* <label>Start</label> */}
            <DesktopDatePicker
              inputFormat="yyyy-MM-dd"
              value={startDate}
              fullWidth
              label="Start"
              onChange={handleStartDate}
              renderInput={(params) => (
                <TextField {...params} className="mt-8 mb-16" fullWidth />
              )}
              sx={{ width: '100%'}}
            />
          </Box>
          <Box sx={{ mb: 2 }}>
            {/* <label>End</label> */}
            <DesktopDatePicker
              inputFormat="yyyy-MM-dd"
              value={endDate}
              fullWidth
              label="End"
              // minDate={new Date()}
              // maxDate={form.end || undefined}
              onChange={handleEndDate}
              renderInput={(params) => (
                <TextField {...params} className="mt-8 mb-16" fullWidth />
              )}
              sx={{ width: '100%'}}
            />
          </Box>
          <Box sx={{ mb: 3 }}>
            <Select
              name="assignDesigner"
              options={optionsDesignerList}
              styles={customStyles()}
              onChange={handleUserChange}
            />
          </Box>
          <Button
            variant="contained"
            color="warning"
            size="large"
            onClick={() => handleClose({ startDate: startDate, endDate: endDate, user: selectedUser })}
          >
            Send Acknowledge
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
